import ChangeFastCashRateModal from './ChangeFastCashRateModal';

export default ChangeFastCashRateModal;
